export default __webpack_public_path__ + "static/media/DP1500i.fd89f030.pdf";